import {
  PurchasingDecisionTimeline,
  SampleRequestEstimatedAnnualUsage,
  SampleRequestProjectType,
  SampleRequestSupportRequestType,
} from "../../api/public";

export const ESTIMATED_ANNUAL_USAGE_LABEL_MAP: Record<
  SampleRequestEstimatedAnnualUsage,
  string
> = {
  [SampleRequestEstimatedAnnualUsage.LESS_THAN_50KG]: "< 50kg",
  [SampleRequestEstimatedAnnualUsage.BETWEEN_50_AND_500KG]: "50-500kg",
  [SampleRequestEstimatedAnnualUsage.BETWEEN_501_AND_1000KG]: "501-1000kg",
  [SampleRequestEstimatedAnnualUsage.BETWEEN_1_AND_20_TONS]: "1-20 tons",
  [SampleRequestEstimatedAnnualUsage.BETWEEN_20_AND_100_TONS]: "20-100 tons",
  [SampleRequestEstimatedAnnualUsage.MORE_THAN_100_TONS]: "> 100 tons",
};

export const ESTIMATED_ANNUAL_USAGE_OPTIONS = Object.entries(
  ESTIMATED_ANNUAL_USAGE_LABEL_MAP
).map(
  ([value, label]) =>
    ({ value, label } as {
      value: SampleRequestEstimatedAnnualUsage;
      label: string;
    })
);

export const SAMPLE_REQUEST_SUPPORT_REQUEST_TYPE_LABEL_MAP: Record<
  SampleRequestSupportRequestType,
  string
> = {
  [SampleRequestSupportRequestType.SPEAK_TO_SALES_REP]: "Speak to a Sales Rep",
  [SampleRequestSupportRequestType.SPEAK_TO_TECHNICAL_STAFF]:
    "Speak to Technical Staff",
  [SampleRequestSupportRequestType.PRICE_QUOTE]: "Request Pricing",
  [SampleRequestSupportRequestType.DOCUMENTATION_TECHNICAL_INFORMATION]:
    "Request Product Documentation",
  [SampleRequestSupportRequestType.PROJECT_TOO_NEW]:
    "None / Project is Too New",
};

export const SUPPORT_REQUESTS_OPTIONS = Object.entries(
  SAMPLE_REQUEST_SUPPORT_REQUEST_TYPE_LABEL_MAP
).map(
  ([value, label]) =>
    ({ value, label } as {
      value: SampleRequestSupportRequestType;
      label: string;
    })
);

export const PURCHASING_DECISION_TIMELINE_LABEL_MAP: Record<
  PurchasingDecisionTimeline,
  string
> = {
  [PurchasingDecisionTimeline.ASAP]: "ASAP",
  [PurchasingDecisionTimeline._1_TO_3_MONTHS]: "1-3 Months",
  [PurchasingDecisionTimeline._3_TO_6_MONTHS]: "3-6 Months",
  [PurchasingDecisionTimeline._6_TO_12_MONTHS]: "6-12 Months",
  [PurchasingDecisionTimeline.MORE_THAN_12_MONTHS]: "> 12 Months",
};

export const PURCHASING_DECISION_TIMELINE_OPTIONS = Object.entries(
  PURCHASING_DECISION_TIMELINE_LABEL_MAP
).map(
  ([value, label]) =>
    ({ value, label } as {
      value: PurchasingDecisionTimeline;
      label: string;
    })
);

export const PROJECT_TYPE_LABEL_MAP: Record<SampleRequestProjectType, string> =
  {
    [SampleRequestProjectType.NEW_FORMULA_DEVELOPMENT]:
      "New formula development",
    [SampleRequestProjectType.FORMULA_ENHANCEMENT]: "Formula enhancement",
    [SampleRequestProjectType.TROUBLESHOOTING_EXISTING_FORMULA]:
      "Troubleshooting existing formula",
    [SampleRequestProjectType.EXPLORING_RAW_MATERIALS_FOR_EXISTING_FORMULA]:
      "Exploring raw materials for existing formula",
    [SampleRequestProjectType.EXPLORING_ALTERNATE_RAW_MATERIALS_FOR_EXISTING_FORMULA]:
      "Exploring alternate raw materials for existing formula",
  };

export const PROJECT_TYPE_OPTIONS = Object.entries(PROJECT_TYPE_LABEL_MAP).map(
  ([value, label]) =>
    ({ value, label } as {
      value: SampleRequestProjectType;
      label: string;
    })
);
